import { ReactNode } from 'react';

import AuthBackground from '@/assets/images/auth/AuthBackground';

import AuthCard from './AuthCard';

interface Props {
  children: ReactNode;
}

const AuthWrapper = ({ children }: Props) => (
  // Soft backdrop colour matches the photo edges so the image does not look cut off.
  // Content stays at z-10 above the sushi photo at z-0.
  <div className="relative min-h-screen overflow-hidden bg-auth-backdrop">
    <AuthBackground />
    <div className="relative z-10 flex min-h-screen flex-col justify-end">
      <div className="flex min-h-auth-content items-center justify-center sm:min-h-auth-content-sm md:min-h-auth-content-md">
        <AuthCard>{children}</AuthCard>
      </div>
      <div className="m-6 mt-2">
        <img src="/app-logo.png" alt="App Logo" width="60" />
      </div>
    </div>
  </div>
);

export default AuthWrapper;
